import { useState, useEffect, useCallback, useRef } from "react";
import { useApiError } from "./useApiError";
import { BitmakerAPIClient } from "../services/BitmakerApp";
import {
  SprintNavigation,
  SprintNavigationFromJSON,
} from "../bitmaker/schemas/Sprints/SprintNavigation";

export const useSprintNavigation = (sprintId?: string) => {
  const [sprintNavigation, setSprintNavigation] =
    useState<SprintNavigation | null>(null);
  const [loadingSprintNavigation, setLoadingSprintNavigation] = useState(false);
  const [fetchSprintNavigationError, setFetchSprintNavigationError] = useState<
    string | null
  >(null);

  const { handleAPIError } = useApiError();
  const isMountedRef = useRef(false);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const fetchSprintNavigation = useCallback(() => {
    if (!isMountedRef.current) return;

    setLoadingSprintNavigation(true);
    setFetchSprintNavigationError(null);

    const url = sprintId
      ? `/sprints/${sprintId}/navigation`
      : `/sprints/current/navigation`;

    BitmakerAPIClient.get(url, null, (response) => {
      if (!isMountedRef.current) return;

      const { isError, message } = handleAPIError(response);

      if (isError) {
        console.error("Error fetching sprint navigation:", message);
        setFetchSprintNavigationError(
          "Error fetching sprint. Please try again.",
        );
        setSprintNavigation(null);
        setLoadingSprintNavigation(false);
        return;
      }

      setSprintNavigation(
        response.data ? SprintNavigationFromJSON(response.data) : null,
      );
      setLoadingSprintNavigation(false);
    });
  }, [sprintId, handleAPIError]);

  useEffect(() => {
    fetchSprintNavigation();
  }, [fetchSprintNavigation]);

  return {
    sprintNavigation,
    loadingSprintNavigation,
    fetchSprintNavigationError,
    refetchSprintNavigation: fetchSprintNavigation,
  };
};
